import { inject, Injectable } from '@angular/core';
import { MatSidenav } from "@angular/material/sidenav";
import { Subject } from "rxjs";
import { VariablesService } from './variables.service';

interface MainSidenavData {
  template?: any,
  inputs?: any,
  disableBackdrop?: boolean
}

@Injectable({
  providedIn: 'root'
})
export class SidenavService {
  // Set in layout.component.ts
  sidenav!: MatSidenav;

  data: MainSidenavData = {};

  afterClosed!: Subject<any>;

  readonly variablesService: VariablesService = inject(VariablesService);

  open<R = any>(data: MainSidenavData): { afterClosed: Subject<R> } {
    this.afterClosed = new Subject<R>();
    this.data = data;

    if (!this.sidenav) {
      console.error('Sidenav is not initialized yet');
      return { afterClosed: this.afterClosed };
    }

    this.sidenav.open().then(() => {
      // Check if backdrop is disabled
      if (data.disableBackdrop) {
        // Force remove backdrop
        setTimeout(() => {
          const backdrop = document.querySelector('.mat-drawer-backdrop');
          if (backdrop) {
            (backdrop as HTMLElement).style.display = 'none';
          }
        }, 100);
      }
    }).catch((error) => {
      console.error('Error opening sidenav:', error);
    });
    return { afterClosed: this.afterClosed };
  }

  close(result?: any): void {
    this.variablesService.isHideScrollInSidebar.set(false);
    this.sidenav.close().then();
    if (this.sidenav) {
      this.sidenav.close().then();
    }
    this.afterClosed.next(result);
  }
}
